<template>
  <div class="auth-page">
    <div class="auth-page__backdrop" aria-hidden="true" />

    <AuthHeroPanel />

    <div class="auth-main">
      <div class="auth-panel">
        <div class="auth-panel__card">
          <button type="button" class="auth-panel__back" @click="$emit('back')">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="15,18 9,12 15,6" />
            </svg>
            {{ $t('authBackHome') }}
          </button>

          <div v-if="showTabs" class="auth-panel__tabs">
            <button
              type="button"
              class="auth-panel__tab"
              :class="{ 'auth-panel__tab--active': activeTab === 'login' }"
              @click="$emit('tab-change', 'login')"
            >
              {{ $t('authTabLogin') }}
            </button>
            <button
              type="button"
              class="auth-panel__tab"
              :class="{ 'auth-panel__tab--active': activeTab === 'register' }"
              @click="$emit('tab-change', 'register')"
            >
              {{ $t('authTabRegister') }}
            </button>
          </div>

          <div class="auth-panel__heading">
            <h1 class="auth-panel__title">{{ title }}</h1>
            <p v-if="subtitle" class="auth-panel__subtitle">{{ subtitle }}</p>
          </div>

          <slot />
        </div>
      </div>
    </div>

    <AuthAppPromo />
  </div>
</template>

<script>
import AuthHeroPanel from './AuthHeroPanel.vue';
import AuthAppPromo from './AuthAppPromo.vue';

export default {
  name: 'AuthLayout',
  components: { AuthHeroPanel, AuthAppPromo },
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    showTabs: { type: Boolean, default: false },
    activeTab: { type: String, default: 'login' },
  },
  emits: ['back', 'tab-change'],
};
</script>

<style lang="scss">
@import '@/assets/styles/auth.scss';
</style>
